let importExternalComp = [];
try {
  importExternalComp = require("@/exportComponentList.js").default;
} catch (error) {
  console.warn("没有找到低代码相关的暴露本地组件的外部引入文件， 路径为：@/exportComponentList.js", error);
}

export const defaultComponentList = [
  {
    cnName: "流程组件", // 选择流程时所展示的名称
    component: require("@/CommonDP/components/breadcrumb/breadcrumb.vue").default, // 使用的组件
    id: "flowComp" // id不可重复唯一标识
  },
  {
    cnName: "示例组件",
    component: require("@/CommonDP/components/dynamicLocalCodeExample.vue").default,
    id: "dynamicLocalCodeExample"
  }
  // {
  //   cnName: "数据导入",
  //   component: require("@/CommonDP/pages/mainMg/lowcode/tableSettings/uploaderExcel/index.vue").default,
  //   id: "dataImport"
  // }
];

export const componentList = defaultComponentList.concat(importExternalComp);

export const componentDicList = componentList.map((item) => {
  return {
    cnName: item?.cnName || "",
    id: item?.id || ""
  };
});
